import { logException } from "@/analytics/sentry";
import { SupabaseClient } from "@supabase/supabase-js";
import { Database } from "@/data/supabase.types";

export async function updateSmsOptIn(
  supabase: SupabaseClient<Database>,
  userId: string
) {
  const { error } = await supabase
    .from("notification_preferences_alt")
    .update({ has_opted_in_sms: true })
    .eq("user_id", userId);

  if (error) {
    logException(new Error(`Failed to update SMS opt-in: ${error.message}`));
  }
}
